import { Swiper, Navigation, Pagination } from 'swiper/dist/js/swiper.esm.js';
Swiper.use([Navigation, Pagination]);
import ServiceLocator from "../../global/service-locator";
import DOMHelper from "../../lib/dom-helper";

export default class PhotoGallery {
	constructor() {
		this.$root = document.getElementById('modal-photo-gallery');
		this.$triggers = document.querySelectorAll('[data-modal-trigger="photo-gallery"]');
		this.$thumbs = document.querySelectorAll('a[data-gallery-srcset-desktop]');
		this.$slider = document.getElementById('photoGallery');
		this.$pictureContainer = this.$slider.querySelector('.swiper-wrapper');
		this.$prevButton = this.$root.querySelector('.photo-gallery-nav.-prev');
		this.$nextButton = this.$root.querySelector('.photo-gallery-nav.-next');
		this.$pagination = this.$root.querySelector('.photo-gallery-pagination');

		this.modalService = ServiceLocator.instance.modalService;
		this.swiper = null;

		this.swiperConfig = {
			navigation: {
				nextEl: '.photo-gallery-nav.-next',
				prevEl: '.photo-gallery-nav.-prev'
			},
			pagination: {
				el: '.photo-gallery-pagination',
				bulletClass: 'photo-gallery-pagination_bullet',
				bulletActiveClass: '-active',
				clickable: true
			},
			spaceBetween: 30,
			slidesPerView: 1,
			slidesPerGroup: 1,
			loop: true,
			speed: 360,
			breakpoints: {
				768: {
					spaceBetween: 15
				}
			}
		};

		this.moveSlidesByKey = this.moveSlidesByKey.bind(this);

		this.init();
	}

	init() {
		if (!this.$thumbs.length && !this.$triggers.length) {
			return;
		} else if (!this.$slider) {
			throw new Error('PhotoGallery: Gallery slider element is not defined');
		}

		const $triggers = [];

		if (this.$thumbs.length) {
			$triggers.push(...this.$thumbs);
		}

		if (this.$triggers.length) {
			$triggers.push(...this.$triggers);
		}

		// Register photo-gallery modal with thumbs as modal triggers
		this.modalService.register('photo-gallery', $triggers, {
			withCloseBtn: true,
			beforeOpen: (trigger) => {
				const $container = trigger.parentElement;
				const $thumbs = $container.children;

				if ($thumbs.length === 1) {
					this.$prevButton.classList.add('-hidden');
					this.$nextButton.classList.add('-hidden');
					this.$pagination.classList.add('-hidden');
				}
			},
			afterOpen: (trigger) => {
				const $container = trigger.parentElement;
				const $thumbs = $container.children;

				if ($thumbs.length > 1) {
					// Create slide array and reverse it for prepending
					let slides = [];

					if (this.$thumbs.length) {
						slides = Array.from($thumbs).map(($thumb) => {
							return DOMHelper.createElement('li', {
								attributes: {
									class: ['swiper-slide', 'photo-gallery-slide']
								},
								children: [DOMHelper.createElement('picture', {
									attributes: {
										class: 'picture photo-gallery-slide_img'
									},
									children: [
										DOMHelper.createElement('source', {
											attributes: {
												srcset: $thumb.dataset.gallerySrcsetDesktop,
												media: '(min-width: 441px)'
											}
										}),
										DOMHelper.createElement('source', {
											attributes: {
												srcset: $thumb.dataset.gallerySrcsetPhone,
												media: '(max-width: 440px)'
											}
										}),
										DOMHelper.createElement('img', {
											attributes: {
												src: $thumb.dataset.gallerySrcsetDesktop,
												alt: 'Gallery image'
											}
										})
									]
								})]
							});
						}).reverse();
					}

					// Initialize swiper if it's not
					if (!this.swiper) {
						this.swiper = new Swiper(this.$slider, this.swiperConfig);
					}

					if (slides.length) {
						// Prepend slides
						this.swiper.prependSlide(slides);

						// Find slide index respective to the trigger and make it active
						const slideToIndex = Array.from($thumbs).findIndex(($thumb) =>
							$thumb.dataset.gallerySrcsetDesktop === trigger.dataset.gallerySrcsetDesktop);
						this.swiper.slideTo(slideToIndex + 1, 0);
					}

					window.addEventListener('keydown', this.moveSlidesByKey);
				} else {
					const $picture = DOMHelper.createElement('li', {
						attributes: {
							class: ['swiper-slide', 'photo-gallery-slide']
						},
						children: [DOMHelper.createElement('picture', {
							attributes: {
								class: 'picture photo-gallery-slide_img'
							},
							children: [
								DOMHelper.createElement('source', {
									attributes: {
										srcset: $thumbs[0].dataset.gallerySrcsetDesktop,
										media: '(min-width: 441px)'
									}
								}),
								DOMHelper.createElement('source', {
									attributes: {
										srcset: $thumbs[0].dataset.gallerySrcsetPhone,
										media: '(max-width: 440px)'
									}
								}),
								DOMHelper.createElement('img', {
									attributes: {
										src: $thumbs[0].dataset.gallerySrcsetDesktop,
										alt: 'Gallery image'
									}
								})
							]
						})]
					});

					this.$pictureContainer.append($picture);

					if (typeof lozadObserver !== 'undefined' && lozadObserver != null) {
						lozadObserver.observe();
					}
				}

				if (typeof lozadObserver !== 'undefined' && lozadObserver != null) {
					lozadObserver.observe();
				}
			},
			afterClose: () => {
				if (this.swiper && this.$thumbs.length) {
					// Clean slide list
					this.swiper.removeAllSlides();
					window.removeEventListener('keydown', this.moveSlidesByKey);
				} else {
					this.$pictureContainer.innerHTML = '';
					this.$prevButton.classList.remove('-hidden');
					this.$nextButton.classList.remove('-hidden');
					this.$pagination.classList.remove('-hidden');
				}
			}
		});
	}

	moveSlidesByKey(e) {
		if (!this.swiper) return;

		if (e.key === 'ArrowRight') {
			this.swiper.slideNext();
		} else if (e.key === 'ArrowLeft') {
			this.swiper.slidePrev();
		}
	}
}